var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M518.023 175.004L450.247 135.882L385.068 173.52L452.825 212.643L518.023 175.004Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.198 212.643L366.71 87.6382L301.512 50L85 175.005L150.198 212.643Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.756 339.132L301.512 378.255L369.288 339.132L301.512 300.01L233.756 339.132Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M452.827 212.643V387.357L301.512 474.724L150.198 387.357V212.643L85 175.005V424.995L301.512 550L518.025 424.995V175.005L452.827 212.643Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233.756 339.132L301.512 378.255L369.288 339.132L301.512 300.01L233.756 339.132Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M452.827 212.643V387.357L301.512 474.724L150.198 387.357V212.643L85 175.005V424.995L301.512 550L518.025 424.995V175.005L452.827 212.643Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M301.512 221.744L233.756 260.867V339.132L301.512 300.009L369.288 339.132V260.867L301.512 221.744Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.c2e9e76fd8231998a1d4d3020e1a66a2.svg";
export { ForwardRef as ReactComponent };